module.exports = __webpack_public_path__ + "static/media/New Front Door  (3).f00bcadf.jpg";